import React, { useCallback } from 'react';
import { Grid } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import clsx from 'clsx';

import { DesktopIcon } from '../../icon/solid';
import { StudioControlStyles } from '../styles';
import { Button } from '../../index';
import { selectStudioMode } from '../../../store/modules/studio/selectors';
import { setStudioMode } from '../../../store/modules/studio/actions';
import { StudioMode } from '../../../configs/studio';
import StudioToolTip from './StudioToolTip';

const PrompterModeAction = () => {
  const classes = StudioControlStyles();
  const dispatch = useDispatch();
  const studioMode = useSelector(selectStudioMode);
  const isActive = studioMode === StudioMode.TELEPROMPTER;

  const onClick = useCallback(() => {
    if (!isActive) {
      dispatch(setStudioMode(StudioMode.TELEPROMPTER));
    }
  }, [dispatch, isActive]);

  return (
    <Grid item className={classes.mainActionContainer}>
      <StudioToolTip title="Teleprompter control and settings">
        <Button
          onClick={onClick}
          className={clsx(
            classes.button,
            classes.circleButton,
            isActive ? classes.activeButton : '',
          )}
          classes={{
            label: classes.circleButton,
          }}
        >
          <DesktopIcon className={classes.icon} />
        </Button>
      </StudioToolTip>
      <span className={classes.mainActionTitle}>
        Prompter
      </span>
    </Grid>
  );
};

export default PrompterModeAction;
